var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEcr = function SvgEcr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ecr_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.345 33.243c7.37 0 13.346-5.976 13.346-13.347 0-7.372-5.975-13.348-13.346-13.348C5.975 6.548 0 12.524 0 19.896c0 7.371 5.975 13.347 13.345 13.347Z",
    fill: "#9F552B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.345 32.412c7.37 0 13.346-5.976 13.346-13.348 0-7.371-5.975-13.347-13.346-13.347C5.975 5.717 0 11.693 0 19.064c0 7.372 5.975 13.348 13.345 13.348Z",
    fill: "#F58536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.246 12.69a2.163 2.163 0 0 1-2.161-2.162c0-1.192.969-2.16 2.16-2.16 1.193 0 2.162.968 2.162 2.16a2.163 2.163 0 0 1-2.161 2.162Zm0-2.985a.824.824 0 1 0 0 1.647.824.824 0 0 0 0-1.647ZM13.246 20.617a1.553 1.553 0 0 1 0-3.104 1.553 1.553 0 0 1 0 3.104Zm0-2.149a.597.597 0 1 0 .002 1.195.597.597 0 0 0-.002-1.195Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.379 17.274a1.961 1.961 0 0 1 1.731 0h.027l.601-4.617a2.588 2.588 0 0 1-2.979.008l.557 4.609h.063ZM11.188 19.064c0-.279.055-.544.157-.787l-3.997 1.2-2.402 3.568.656.619 2.839-2.695 3.628-.217a2.057 2.057 0 0 1-.88-1.686v-.002ZM19.123 19.475l-3.976-1.192a2.054 2.054 0 0 1-.728 2.469l3.61.216 2.84 2.694.655-.62-2.401-3.567Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.432 23.56h-.738v5.015h.738V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.087 23.024H7.604v6.16h11.483v-6.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03 23.56h-.778v5.015h.778V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.934 23.656v4.823h-.587v-4.823h.587Zm.096-.095h-.778v5.014h.778V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.598 23.56H9.82v5.015h.778V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 23.656v4.823h-.586v-4.823h.586Zm.096-.095H9.82v5.014h.778V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.166 23.56h-.777v5.015h.777V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.07 23.656v4.823h-.586v-4.823h.587Zm.096-.095h-.777v5.014h.777V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.734 23.56h-.778v5.015h.778V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.638 23.656v4.823h-.586v-4.823h.586Zm.096-.095h-.778v5.014h.778V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.302 23.56h-.778v5.015h.778V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.207 23.656v4.823h-.587v-4.823h.587Zm.095-.095h-.778v5.014h.778V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.87 23.56h-.777v5.015h.777V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.775 23.656v4.823h-.587v-4.823h.587Zm.095-.095h-.777v5.014h.777V23.56Z",
    fill: "#FFAA71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.439 23.56h-.778v5.015h.778V23.56Z",
    fill: "#FBBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.343 23.656v4.823h-.586v-4.823h.586Zm.096-.095h-.778v5.014h.778V23.56Z",
    fill: "#FFAA71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ecr_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 5.717)",
    d: "M0 0h26.691v27.526H0z"
  })))));
};

export default SvgEcr;